'use strict';

import { NewIamHelper } from '../helpers/newIamHelper';

angular.module('directives.redirectNewIam', [])

.directive('redirectNewIam', function () {
    function link(scope, element, attrs) {
        const state = attrs.redirectNewIam;

        function updateLink(redirectTo) {
            if (!redirectTo) {
                return;
            }
            element.attr('href', redirectTo);
        }

        if (!state) {
            return;
        }
        updateLink(NewIamHelper.getFullPath(state));

        scope.$watch(attrs.redirectNewIamPathParam, function(param) {
            updateLink(NewIamHelper.getFullPath(state, param));
        });
    }

   return {
        link: link
   };
});
